import React, { useRef } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useSafeArea } from '@/hooks/useSafeArea';
import ScrollContainer from '@/components/common/ScrollContainer';
import { LayoutProvider } from '@/contexts/LayoutContext';

// 临时内联导入，稍后会修复
import TopNavigation from './TopNavigation.tsx';
import BottomTabBar from './BottomTabBar.tsx';

const LayoutContainer = styled.div<{ $safeAreaTop: number; $safeAreaBottom: number }>`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh; /* 动态视口高度，更适合移动设备 */
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.primary};
`;

const TopNavContainer = styled.div<{$safeAreaTop: number; }>`
  position: fixed;
  top: ${({ $safeAreaTop }) => $safeAreaTop}px;
  left: 0;
  right: 0;
  flex-shrink: 0;
  z-index: ${({ theme }) => theme.zIndex.sticky};
  background: transparent;
`;

const ContentArea = styled(motion.div)`
  flex: 1;
  position: relative;
  overflow: hidden; /* 防止内容溢出 */
`;

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
  rightActions?: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  title = "Dopamine",
  showBackButton = false,
  onBackClick,
  rightActions
}) => {
  const safeAreaInsets = useSafeArea();
  const containerRef = useRef<HTMLDivElement>(null)
  return (
    <LayoutProvider 
      safeAreaTop={safeAreaInsets.top}
      safeAreaBottom={safeAreaInsets.bottom}
      containerRef={containerRef}>
      <LayoutContainer 
        $safeAreaTop={safeAreaInsets.top} 
        $safeAreaBottom={safeAreaInsets.bottom}
        ref={containerRef}
      >
        <TopNavContainer $safeAreaTop={safeAreaInsets.top}>
          <TopNavigation
            title={title}
            showBackButton={showBackButton}
            onBackClick={onBackClick}
            rightActions={rightActions}
          />
        </TopNavContainer>
        
        <ContentArea
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <ScrollContainer>
            {children}
          </ScrollContainer>
        </ContentArea>
        
        {/* <BottomTabContainer $safeAreaBottom={safeAreaInsets.bottom}> */}
          <BottomTabBar />
        {/* </BottomTabContainer> */}
      </LayoutContainer>
    </LayoutProvider>
  );
};

export default AppLayout;